var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-rtc-container",attrs:{"id":"player-rtc-container"}},[_c('comp-stream-player',{ref:"streamPlayer",staticClass:"stream-player"}),_c('comp-stream-control',{staticClass:"stream-control"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }